import { useQuery } from '@tanstack/react-query';
import { folderService } from '../services/folderService';

export function useSharedFolders() {
  return useQuery({
    queryKey: ['folders', 'shared-with-me'],
    queryFn: () => folderService.getSharedFolders(),
  });
}
